export { default } from './StyledCheckbox';
